export type PortfolioAssetType = {
  name?: string;
  asset_name?: string;
  total_value?: number;
  quantity?: number;
  market_price?: number;
  pnl?: {
    percent?: number;
    value?: number;
  };
  pnl_value?: number;
  pnl_percent?: number;
  weight?: number;
  free?: number;
  locked?: number;
  provider_ids?: { id: number, type: string }[];
  is_fiat?: boolean;
  asset_details?: { asset_data?: PortfolioAssetDetailsType, asset_name: string, id: number };
  value?: number;
  avg_buy_value?: number;
  avg_sell_value?: number;
  current_price?: number;
  open_orders?: any;
  open_orders_count?: number;
  account_type?: string;
};

export type PortfolioAssetDetailsType = {
  id?: string;
  ath?: number;
  atl?: number;
  roi?: null;
  name?: string;
  image?: string;
  symbol?: string;
  low_24h?: number;
  ath_date?: string;
  atl_date?: string;
  high_24h?: number;
  market_cap?: number;
  max_supply?: number;
  last_updated?: string;
  total_supply?: number;
  total_volume?: number;
  current_price?: number;
  market_cap_rank?: number;
  price_change_24h?: number;
  circulating_supply?: number;
  ath_change_percentage?: number;
  atl_change_percentage?: number;
  market_cap_change_24h?: number;
  fully_diluted_valuation?: number;
  price_change_percentage_24h?: number;
  market_cap_change_percentage_24h?: number;
  price_change_percentage_7d_in_currency?: number;
  price_change_percentage_14d_in_currency?: number;
};

export interface TopTradedPair {
  symbol: string;
  count: number;
}

export interface N24hValuation {
  value: string;
  percentage: string;
}

export interface N7dValuation {
  value: string;
  percentage: string;
}

export interface PortfolioHoldingsType {
  id: number;
  provider: number;
  name: string;
  exchange_name: string;
  assets: Asset[];
  portfolio_pnl: PortfolioPnl;
  evaluation: number;
  trade_sync_status: string;
  last_orders_synch_date: any;
  type?: string;
}

export interface Asset {
  name: string;
  free: number;
  locked: number;
  weight: number;
  value: number;
  avg_price: any;
  pnl: Pnl;
  provider_name: any;
  provider_id: any;
  provider_ids: any[];
  avg_buy_value: number;
  avg_sell_value: number;
  current_price: number;
  open_orders: OpenOrders;
  providers: { id: number, type: string }[]
  asset_details?: { asset_data?: PortfolioAssetDetailsType, asset_name: string, id: number };
  account_type: string;
  asset_name?: string;
  total_value?: number;
  quantity?: number;
  market_price?: number;
  pnl_value?: number;
  pnl_percent?: number;
  is_fiat?: boolean;
}

export interface Pnl {
  value: number;
  percent: number;
}

export interface OpenOrders {
  sell: number;
  buy: number;
}

export interface AssetDetails {
  id: string;
  name: string;
  image: string;
  symbol: string;
  market_cap?: number;
  current_price: number;
  market_cap_rank?: number;
  price_change_24h?: number;
  price_change_percentage_24h?: number;
  price_change_percentage_1h_in_currency?: number;
  price_change_percentage_7d_in_currency?: number;
  price_change_percentage_14d_in_currency?: number;
  price_change_percentage_24h_in_currency?: number;
}

export interface PortfolioPnl {
  value: number;
  percent: number;
}

export type SnapShots = snapshotItem[];

export interface snapshotItem {
  created_at: string;
  total_evaluation: number;
}

export enum orderTypesEnums {
  TP = "Take Profit",
  SL = "Stop Loss",
  T_TP = "Trailing Take Profit",
  T_SL = "Trailing Stop Loss",
  ENTRY = "Entry",
}

export enum orderOriginEnums {
  smart_allocation_rebalance = "SA Rebalancing",
  manual_order = "Manual order",
  smart_allocation_exit_strategy = "SA exit strategy",
  close_exposure = "Close exposure",
  migrated_from_provider = "From exchange",
  smart_allocation_rollback = "SA rollback",
  manual_order_rollback = "Order rollback",
  dust_migrated_from_provider = "Dust conversion",
}

export enum ordersSideEnums {
  BUY = "Buy",
  SELL = "Sell",
}

export enum ordersSourcesEnums {
  smart_allocation_rebalance = "Rebalancing",
  manual_order = "Manual trade",
  smart_allocation_exit_strategy = "Exit Strategy",
}

export enum ordersStatusEnums {
  Fulfilled = "200",
  "Broker Error" = "-200",
}

export const StatusEnums: { [key: number]: string } = {
  "200": "Fulfilled",
  "-200": "Broker Error",
}
